import { get, post } from '../../requestNew';

export type Category = 'NEWS' | 'JIUYANG';
export interface ScoreRule {
  key: string;
  label: string;
  field: string;
  points: number;
  terms: string[];
}
export interface ScoreConfig {
  schemaVersion: number;
  displayThreshold: number;
  featuredThreshold: number;
  featuredExclusive: boolean;
  windowDays: number;
  themeRelevanceMin: number;
  rankTiers: { maxRank: number; points: number }[];
  resistanceRankTiers: { maxRank: number; points: number }[];
  platformTiers: { minPlatforms: number; points: number }[];
  rules: ScoreRule[];
}
export interface RuleVersion {
  category: Category;
  version: string;
  actor: string;
  createdAt: string;
  canWrite: boolean;
  config: ScoreConfig;
}
export interface ScoreEvidence {
  status: 'NOT_APPLICABLE' | 'PENDING' | 'PASSED' | 'FILTERED';
  category?: Category;
  version?: string;
  total?: number;
  featured?: number;
  breakdown?: { key: string; label: string; matched: boolean; matches: string[]; points: number }[];
  context?: unknown;
}
interface Envelope<T> {
  code: number;
  message?: string;
  data: T;
}
async function unwrap<T>(request: Promise<Envelope<T>>): Promise<T> {
  const value = await request;
  if (value.code !== 200 || value.data == null) throw new Error(value.message || '评分规则接口异常');
  return value.data;
}
const ROOT = '/agent/admin/v1/messages';
const inlineError = () => undefined;
export const scoringApi = {
  get: (category: Category) => unwrap(get<Envelope<RuleVersion>>(`${ROOT}/scoring-rules/${category}`, {}, inlineError)),
  save: (category: Category, baseVersion: string, config: ScoreConfig) =>
    unwrap(post<Envelope<RuleVersion>>(`${ROOT}/scoring-rules/${category}`, { baseVersion, config }, inlineError)),
  score: (id: string) =>
    unwrap(get<Envelope<ScoreEvidence>>(`${ROOT}/${encodeURIComponent(id)}/score`, {}, inlineError))
};
